import { newsApi } from './api';
import {
    DRIVER_APPLICATION_ENDPOINT, DRIVER_EDIT_APPLICATION_ENDPOINT
} from "./apiConstant";

export const AppliactionService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getApplication: build.query({
            query: (params) => ({
                url: `${DRIVER_APPLICATION_ENDPOINT}/${params?.systemID}/${params?.driverId}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },

            }),
            providesTags: ['Application'],
        }),
        saveApplication: build.mutation({
            query: ({ params, newForm }) => ({
                url: `${DRIVER_APPLICATION_ENDPOINT}/${params?.systemID}/${params?.driverId}`,
                method: 'POST',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Application'],
        }),
        editRequestApplication: build.mutation({
            query: (params) => ({
                url: `${DRIVER_EDIT_APPLICATION_ENDPOINT}/${params?.systemID}/${params?.driverId}`,
                method: 'GET',
            }),
            invalidatesTags: ['Application'],
        }),

    }),
    overrideExisting: false,
})

export const { useGetApplicationQuery, useSaveApplicationMutation, useEditRequestApplicationMutation } = AppliactionService